export const TimerCongratulatoryFlowPageStates = {
  STREAK: 'streak',
  ADD_PRACTICE: 'addPractice',
}
